
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manfredite",
      function () {
        return require("private-next-pages/manfredite.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manfredite"])
      });
    }
  